































import MessageComponent from '@/shared/components/Message.vue';
import ResultComponent from '../Result/Result.vue';
import InfiniteScrollTrigger from '@/shared/components/InfiniteScrollTrigger.vue';
import LoaderComponent from '@/shared/components/Loader.vue';
import {defineComponent} from "@vue/composition-api";
import {useGetters} from "vuex-composition-helpers";
import InnerLoader from "@/shared/components/atoms/InnerLoader.vue";

export default defineComponent({
    name: "ResultsList",
    components: {
        InnerLoader,
        MessageComponent,
        ResultComponent,
        InfiniteScrollTrigger,
        LoaderComponent
    },
    methods: {
        numberOfResultsLabel(): string {
            let label: string | undefined = this.$store.getters.labels?.numberOfResults;
            return label ? label.replace(/\{0}/g, this.$store.getters.totalResults) : "";
        },
        loadMore(): void {
            if (!this.$store.getters.lastResult) {
                this.$store.dispatch('loadData', [true, false]);
            }
        },
        loadAll(): void {
            this.$store.dispatch('loadData', [true, true]);
        }
    },
    setup: () => {
        const {
            labels,
            searchQuery,
            results,
            totalResults,
            lastResult,
            loading,
            innerLoading
        } = useGetters(["labels", "searchQuery", "results", "totalResults", "lastResult", "loading", "innerLoading"])

        return {
            labels,
            searchQuery,
            results,
            totalResults,
            lastResult,
            loading,
            innerLoading
        }
    }
})
